import { render, staticRenderFns } from "./EmbedVideoYoutube.vue?vue&type=template&id=2c2d9e78&scoped=true&"
import script from "./EmbedVideoYoutube.vue?vue&type=script&lang=js&"
export * from "./EmbedVideoYoutube.vue?vue&type=script&lang=js&"
import style0 from "./EmbedVideoYoutube.vue?vue&type=style&index=0&id=2c2d9e78&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2d9e78",
  null
  
)

export default component.exports